import { inject, Injector } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, firstValueFrom } from 'rxjs';
import { ERROR_URL } from 'src/app/app/app.constants';
import { complianceDoctorAudience } from 'src/app/common/menu-def.provider';
import { GrowthBookService } from 'src/app/services/growthbook/service';
import { AuthState } from 'src/app/store/auth/auth.state';

/**
 * Restricts direct URL access to the Compliance Doctor painted-door page to the
 * same segment that controls its menu visibility (owners/admins/managers at 50+
 * seat, trial-or-paid companies). Mirrors the `complianceDoctorAudience`
 * MenuCondition so the route and the nav entry can never drift apart.
 */
export const complianceDoctorAccessGuard: CanActivateFn = async () => {
  const store = inject(Store);
  const router = inject(Router);
  const injector = inject(Injector);
  const errorUrl = inject(ERROR_URL);
  const growthbook = inject(GrowthBookService);

  // Wait for GrowthBook to be initialized before reading the feature flag.
  // `complianceDoctorAudience` reads `compliance-doctor` synchronously, so on a
  // cold load / deep-link the flag would otherwise resolve to its default (false)
  // during GB's pre-init window and wrongly redirect qualified users. Mirrors
  // upsellRedirectGuard, the established pattern for flag-gated report routes.
  await firstValueFrom(growthbook.initialized.pipe(filter(x => x)));

  const company = store.selectSnapshot(AuthState.company);

  if (company && complianceDoctorAudience(company, injector)) {
    return true;
  }

  return router.createUrlTree([errorUrl, 'unauthorized']);
};
